import YouTrendLogo from '@/assets/img/youtrend.png';
import * as React from 'react';
import './index.scss';

export const Header = () => (
  <div className="Header">
    <h1 className="Header__title">
      La mappa interattiva dei collegi uninominali
    </h1>
    <a href="https://www.youtrend.it/" target="__blank">
      <div
        className="Header__YouTrendLogo"
        style={{ backgroundImage: `url(${YouTrendLogo})` }}
      />
    </a>
  </div>
);
